import { Image, Offcanvas } from 'react-bootstrap'
import logoHRMSIcon from '../../../images/logo.svg'
import { useEffect } from 'react'
import { versionBackEndAPI } from '../../../services/login'
import _ from 'lodash'
import {
  useApiVersionStore,
  useIsShowMenuListStore,
  useMenuLayoutStore,
  useToggleMenuStore
} from '../../../store/layout'
import MenuMainComponent from './MenuMainComponent'
import {
  TbLayoutSidebarLeftCollapse,
  TbLayoutSidebarLeftExpand
} from 'react-icons/tb'
import { FOOTER_VERSION } from '../../../Constants'

const MenuPage = () => {
  const { showMenu, setShowMenu } = useIsShowMenuListStore()
  const { isLoading } = useMenuLayoutStore()
  const { setApiVersion } = useApiVersionStore()
  const { isToggleMenu, setIsToggleMenu } = useToggleMenuStore()
  const { menuLayout } = useMenuLayoutStore()

  useEffect(() => {
    const getVersionBackEnd = async () => {
      const res = await versionBackEndAPI()
      if (!res) return
      if (res.status) {
        setApiVersion(res.result.version)
      }
    }
    getVersionBackEnd()
  }, [setApiVersion])

  return (
    <>
      <div className="d-none d-lg-block">
        <div
          className="shadow-sm"
          style={{
            position: 'fixed',
            backgroundColor: '#fff',
            height: '100vh',
            width: isToggleMenu ? 240 : 77,
            transition: 'margin-left 0.3s ease-in-out'
          }}
        >
          <div
            style={{
              height: '100vh',
              overflowX: 'auto',
              backgroundColor: '#fff'
            }}
          >
            <div
              className={`d-flex ${isToggleMenu ? 'justify-content-between' : 'justify-content-center'} p-3`}
              style={{
                padding: '16px',
                position: 'sticky',
                top: '0rem',
                zIndex: 10,
                background:
                  'linear-gradient(0deg,rgba(255, 255, 255, 0) 3%,rgba(255, 255, 255, 1) 35%)'
              }}
            >
              <div className="my-auto " style={{ height: 40 }}>
                {isToggleMenu ? (
                  <Image src={logoHRMSIcon} fluid width={105} />
                ) : null}
              </div>

              <div
                onClick={() => {
                  setIsToggleMenu(!isToggleMenu)
                }}
                className="text-center pointer-event my-auto"
              >
                {isToggleMenu ? (
                  <TbLayoutSidebarLeftCollapse
                    size={24}
                    style={{
                      strokeWidth: 1.5,
                      color: 'var(--color-on-base-content-low)'
                    }}
                  />
                ) : (
                  <TbLayoutSidebarLeftExpand
                    size={24}
                    style={{
                      strokeWidth: 1.5,
                      color: 'var(--color-on-base-content-low)'
                    }}
                  />
                )}
              </div>
            </div>

            {isLoading ? (
              <div
                className="mt-4 mb-4"
                style={{
                  transition: 'margin-left 0.3s ease-in-out'
                }}
              >
                {_.range(5).map((i) => (
                  <div key={i} className="text-center mt-2">
                    <span className="placeholder h2 rounded-2 col-6"></span>
                  </div>
                ))}
              </div>
            ) : (
              <div>
                {/* <MenuMainComponent /> */}
                <div
                  className="p-3"
                  style={{
                    transition: 'margin-left 0.3s ease-in-out'
                  }}
                >
                  {menuLayout.map((d, i) => {
                    return (
                      <div key={i}>
                        <MenuMainComponent
                          detail={d}
                          isToggleMenu={isToggleMenu}
                        />
                      </div>
                    )
                  })}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* <SubMenuComponent /> */}
      </div>
      <Offcanvas
        show={showMenu}
        onHide={() => setShowMenu(false)}
        className="bg-sky d-grid align-content-between"
        style={{ width: '240px' }}
      >
        <div className="overflow-auto">
          <Offcanvas.Header
            closeButton
            className="text-center pt-4 pb-3 "
            style={{
              position: 'sticky',
              top: '0rem',
              zIndex: 10,
              background:
                'linear-gradient(0deg,rgba(255, 255, 255, 0) 3%,rgba(255, 255, 255, 1) 35%)'
            }}
          >
            <Image src={logoHRMSIcon} fluid width={100} />
          </Offcanvas.Header>
          <div>
            <div
              className="p-3"
              style={{
                transition: 'margin-left 0.3s ease-in-out'
              }}
            >
              {menuLayout.map((d, i) => {
                return (
                  <div key={i}>
                    <MenuMainComponent detail={d} isToggleMenu={true} />
                  </div>
                )
              })}
            </div>
          </div>
        </div>

        <div
          style={{ fontSize: 10, position: 'sticky', bottom: '0px' }}
          className="fw-light text-center text-muted mt-4 pt-2 mb-3 bg-white"
        >
          IT@SkyICT PCL.All {FOOTER_VERSION}{' '}
        </div>
      </Offcanvas>
    </>
  )
}

export default MenuPage
